import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

import {CustomLink, Translation } from '@troy/shared/src/components/common';

export const LINKS = [
  {
    id: 'footer-faq',
    to: 'https://hilfe.troy.de/',
    text: 'UNIC_UXCOPIES_FOOTER_FAQ'
  },
  {
    id: 'footer-statement',
    to: 'https://www.troy-bleiben.de/datenschutzerklaerung-im-rahmen-einer-geschaeftsbeziehung/',
    text: 'UNIC_UXCOPIES_FOOTER_MISSIONSTATEMENT'
  },
  {
    id: 'footer-impressum',
    to: 'https://www.troy-bleiben.de/impressum/',
    text: 'UNIC_UXCOPIES_FOOTER_IMPRINT'
  }
];

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'inline-flex'
  },
  link: {
    '&:not(:first-of-type)': {
      marginLeft: theme.spacing(2)
    }
  }
}));

const FooterLinks: React.FC<{ className?: string }> = ({ className }) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)}>
      {LINKS.map(({ id, to, text }) => {
        const isExternal = to.startsWith('http://') || to.startsWith('https://');

        return isExternal ? (
          <a
            key={id}
            href={to}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.link}
            id={id}
            style={{
                color: 'white',
                textDecoration: 'none',
                fontSize: '0.875rem',
                fontWeight: 400,
                transition: 'color 0.3s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#B39FCD'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#FFFFFF'}
          >
            <Translation keyIfNoValue>{text}</Translation>
          </a>
        ) : (
          <CustomLink
            key={id}
            variant="secondary"
            typography="body2"
            className={classes.link}
            id={id}
            to={to}
          >
            <Translation keyIfNoValue>{text}</Translation>
          </CustomLink>
        );
      })}
    </div>
  );
};

export default FooterLinks;
